module.exports = __webpack_public_path__ + "img/contract.6d76b208.jpg";